import $ from 'jquery';

class Exam {
    constructor(el, options) {
        /// This code was moved from QuizControl.cshtml
        $(function () {
            $(".tab-step").click(function () {
                $("#ScrollPositionY").val($(document).scrollTop());
                $("#QuizOptions").val($(this).attr('questions'));
                $("#ShowScore").val(0);
                $("#Question1").val(null);
                $("[name=AnswerQuestion1]").removeAttr("checked");
                $("[name=AnswerQuestion2]").removeAttr("checked");
                $("[name=AnswerQuestion3]").removeAttr("checked");
                $("[name=AnswerQuestion4]").removeAttr("checked");
                $("[name=AnswerQuestion5]").removeAttr("checked");
                $("[name=AnswerQuestion6]").removeAttr("checked");
                $("[name=AnswerQuestion7]").removeAttr("checked");
                $("[name=AnswerQuestion8]").removeAttr("checked");
                $("[name=AnswerQuestion9]").removeAttr("checked");
                $("[name=AnswerQuestion10]").removeAttr("checked");
                $("#formoptions").submit();
            });

            $(".new-questions").click(function () {
                $("#ScrollPositionY").val($(document).scrollTop());
                $("#ShowScore").val(0);
                $("#Question1").val(null);
                $("[name=AnswerQuestion1]").removeAttr("checked");
                $("[name=AnswerQuestion2]").removeAttr("checked");
                $("[name=AnswerQuestion3]").removeAttr("checked");
                $("[name=AnswerQuestion4]").removeAttr("checked");
                $("[name=AnswerQuestion5]").removeAttr("checked");
                $("[name=AnswerQuestion6]").removeAttr("checked");
                $("[name=AnswerQuestion7]").removeAttr("checked");
                $("[name=AnswerQuestion8]").removeAttr("checked");
                $("[name=AnswerQuestion9]").removeAttr("checked");
                $("[name=AnswerQuestion10]").removeAttr("checked");
                $("#formoptions").submit();
            });

            $("button[name='ShowScore']").click(function () {
                $("#ScrollPositionY").val($(document).scrollTop());
                $("#ShowScore").val(1);
                $("#formoptions").submit();
            });

            $(".showAnswers").click(function () {
                $("#ScrollPositionY").val($(document).scrollTop());
                $("#ShowScore").val(2);
                $("#formoptions").submit();
                //$('.show-hide-question').show();
            });

            $('.question-nr-1').show();
            if (options.showScore == 2){
            $('.show-hide-question').show();
            } else if (options.showScore == 1) {
            $('.show-hide-question').hide();
        }

        $('.show-next-question').click(function () {
            $("#ScrollPositionY").val($(document).scrollTop());
            var counter = $(this).attr('data-type');
            if ($("[name=AnswerQuestion" + (counter - 1) + "]:checked").length == 0) {
                return;
            }

            $('.show-hide-question').hide();
            var questionNr = ".question-nr-" + counter;
            $(questionNr).show();

            if (counter > 10) {
                $("#ShowScore").val(1);
                $("#formoptions").submit();
            }
        });
    });
    }
}

export {
    Exam as Exam
};
